import { ShoppingCart } from "lucide-react";
import { Button } from "../ui/button";
import { useNavigate } from "react-router";
export const EmptyCart = () => {
  const navigate = useNavigate();
  const handleContinueShopping = () => {
    navigate('/');
  };
  return (
    <div className="flex flex-col items-center justify-center py-16 px-5 text-center">
      <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-6">
        <ShoppingCart className="w-12 h-12 text-gray-400" />
      </div>
      
      <h2 className="text-xl font-bold text-black mb-2">Your cart is empty</h2>
      <p className="text-gray-600 mb-8 max-w-sm">
        Looks like you haven&apos;t added any items to your cart yet. Start shopping to fill it up!
      </p>
      
      <Button
        onClick={handleContinueShopping}
        className="px-8 py-3 rounded-full font-semibold"
      >
        Continue Shopping
      </Button>
    </div>
  );
};